<img *ngIf="url" class="h-full w-full" [src]="sanitizeUrl(url)" />
<span *ngIf="!url" class="uppercase">
   @if(titleText === 'NA'){
      <svg-icon src="@assets/images/icons/user-solid.svg" class="block text-slate-100"></svg-icon>
   }@else{
      {{ titleText }}
   }
</span>
